var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"count-down"},[_c('span',[_vm._v(_vm._s(_vm.hours))]),_c('div',[_vm._v(" : ")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.minutes))]),_c('div',[_vm._v(" : ")]),_c('span',[_vm._v(_vm._s(_vm.seconds))])])}
var staticRenderFns = []

export { render, staticRenderFns }